export const randomSharedContent = (): { data: SharedResource[]} => ({ data: sharedContents});
export type SharedResource = {
  resourceId: string;
  resourceType: string;
  userId: string;
  isPrivate: boolean;
  createdAt: string;
  updatedAt: string;
  platform: string;
  companyId: string;
  isLive: boolean;
  resourceName: string;
  companyName: string;
};
const sharedContents: SharedResource[] = [
  {
    resourceId: "xxxx",
    resourceType: "type",
    userId: "asvvv",
    isPrivate: false,
    createdAt: "2024-12-03T07:17:47.000Z",
    updatedAt: "2024-12-03T07:17:47.000Z",
    platform: "platform",
    companyId: "sdfeoej",
    isLive: true,
    resourceName: "xxxxx",
    companyName: "xxxxxx",
  },
  {
    resourceId: "xxx1",
    resourceType: "type1",
    userId: "asv1v",
    isPrivate: false,
    createdAt: "2024-12-03T07:17:47.000Z",
    updatedAt: "2024-12-03T07:17:47.000Z",
    platform: "platform1",
    companyId: "sdfe1ej",
    isLive: true,
    resourceName: "xxx1x",
    companyName: "xxxx1x",
  },
  {
    resourceId: "xxx2",
    resourceType: "type2",
    userId: "asv2v",
    isPrivate: false,
    createdAt: "2024-12-03T07:17:47.000Z",
    updatedAt: "2024-12-03T07:17:47.000Z",
    platform: "platform2",
    companyId: "sdfe2ej",
    isLive: true,
    resourceName: "xxx2x",
    companyName: "xxxx2x",
  },
];
